export const koosScoreData = [
  { raw_score: 0, interval_score: 100.0 },
  { raw_score: 1, interval_score: 91.975 },
  { raw_score: 2, interval_score: 84.6 },
  { raw_score: 3, interval_score: 79.914 },
  { raw_score: 4, interval_score: 76.332 },
  { raw_score: 5, interval_score: 73.342 },
  { raw_score: 6, interval_score: 70.704 },
  { raw_score: 7, interval_score: 68.284 },
  { raw_score: 8, interval_score: 65.994 },
  { raw_score: 9, interval_score: 63.776 },
  { raw_score: 10, interval_score: 61.583 },
  { raw_score: 11, interval_score: 59.381 },
  { raw_score: 12, interval_score: 57.14 },
  { raw_score: 13, interval_score: 54.84 },
  { raw_score: 14, interval_score: 52.465 },
  { raw_score: 15, interval_score: 50.012 },
  { raw_score: 16, interval_score: 47.487 },
  { raw_score: 17, interval_score: 44.905 },
  { raw_score: 18, interval_score: 42.281 },
  { raw_score: 19, interval_score: 39.625 },
  { raw_score: 20, interval_score: 36.931 },
  { raw_score: 21, interval_score: 34.174 },
  { raw_score: 22, interval_score: 31.307 },
  { raw_score: 23, interval_score: 28.251 },
  { raw_score: 24, interval_score: 24.875 },
  { raw_score: 25, interval_score: 20.941 },
  { raw_score: 26, interval_score: 15.939 },
  { raw_score: 27, interval_score: 8.291 },
  { raw_score: 28, interval_score: 0.0 },
];
